import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDGNLbLvx4mZBC1wDYwxmE0h5attXlsHd8",
  authDomain: "sleepy-goodall.firebaseapp.com",
  projectId: "sleepy-goodall",
  storageBucket: "sleepy-goodall.firebasestorage.app",
  messagingSenderId: "313863524723",
  appId: "1:313863524723:web:501940cfd373daf324f506",
  measurementId: "G-6HLQ5F5Y3L",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
